// Tiny WhatsApp click-to-chat helper.
// Number is loaded from /api/content/contact (super-admin editable).
// Falls back to REACT_APP_WHATSAPP_NUMBER env var if API isn't reachable yet.

const FALLBACK = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
let _number = FALLBACK;

async function _refresh() {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    const r = await fetch(`${base}/api/content/contact`);
    if (!r.ok) return;
    const d = await r.json();
    const n = String(d?.whatsapp_number_dial || "").replace(/\D/g, "");
    if (n) _number = n;
  } catch (_) { /* ignore */ }
}
_refresh(); // load once on page load

export function waUrl(message = "") {
  const text = encodeURIComponent(message || "");
  const base = _number ? `https://wa.me/${_number}` : "https://wa.me/";
  return text ? `${base}?text=${text}` : base;
}

export function openWhatsApp(message = "") {
  _refresh(); // pick up admin changes on next click
  if (typeof window !== "undefined") {
    window.open(waUrl(message), "_blank", "noopener");
  }
}

export const DEFAULT_GREETING =
  "Hi The CineVibe! I'd like to plan a private screening. Could you help me with options and availability?";
